import './styles.css'
const LoadingSpinner = () => {
  return (
    <div className="loading-overlay">
      <span className="spinner spinner--dotted"></span>
    </div>
  )
}

export default LoadingSpinner
